<div class="page-header">
  <app-page-title></app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form class="d-flex align-items-center justify-content-between gap-2 flex-wrap" (ngSubmit)="search()">
      <div class="d-flex align-items-center gap-2">
        <div class="input-group input-group-sm master-search-group">
          <input type="text" class="form-control" name="term"
                 placeholder="ข้อมูลอ้างอิง"
                 [ngModel]="term()"
                 (ngModelChange)="term.set($event)"/>
          <button class="btn btn-default" type="submit">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-default" (click)="reset()">ล้าง</button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <select class="form-select form-select-sm filter-select"
                name="action"
                [ngModel]="action()"
                (ngModelChange)="action.set($event); search()">
          <option value="">- การกระทำ -</option>
          <option value="getURI">getURI : เรียกโปรแกรมลงลายมือชื่อ</option>
          <option value="getData">getData : ดึงข้อมูลใบคำขอมา Sign</option>
          <option value="postData">postData : ลงลายมือชื่ออิเล็กทรอนิกส์</option>
        </select>

        <select class="form-select form-select-sm filter-select"
                name="status"
                [ngModel]="status()"
                (ngModelChange)="status.set($event); search()">
          <option value="">- สถานะ -</option>
          <option value="success">Success</option>
          <option value="error">Error</option>
        </select>
      </div>
    </form>
  </div>

  <div class="card-subheader px-3 py-2 border-bottom bg-white d-flex align-items-center gap-2">
    <span class="text-body-secondary small">Show</span>
    <app-pagesize-select size="sm" [value]="pageData().page.size"
                         (valueChange)="onPageSizeChange($event)"/>
    <span class="text-body-secondary small">entries</span>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap class="text-center">No.</th>
            <th nowrap>ข้อมูลอ้างอิง</th>
            <th nowrap>IP Address</th>
            <th nowrap>วัน/เวลา</th>
            <th nowrap>โปรแกรมที่ใช้</th>
            <th nowrap>การกระทำ</th>
            <th nowrap>สถานะ</th>
            <th>ข้อความ</th>
          </tr>
        </thead>
        <tbody>
          @if (pageData()?.content?.length === 0) {
            <tr>
              <td colspan="8" class="text-center py-4 text-body-secondary">- ไม่มีข้อมูล -</td>
            </tr>
          } @else {
            @for (row of pageData()?.content; track row.id; let i = $index) {
              <tr>
                <td class="text-center">{{ (pageData().page?.size * pageData().page?.number) + (i + 1) }}</td>
                <td>
                  @for (entry of parseReference(row.reference); track entry[0]) {
                    <div>{{ entry[0] }}: {{ entry[1] }}</div>
                  }
                </td>
                <td nowrap>{{ row.ipAddress || '-' }}</td>
                <td nowrap>{{ toDate(row.dateTime) | thaidatetime }}</td>
                <td>{{ row.userAgent || '-' }}</td>
                <td nowrap>{{ ACTION_LABELS[row.action] || row.action || '-' }}</td>
                <td>
                  @if (row.status) {
                    <span class="status-badge"
                          [class.status-badge--success]="statusBadgeClass(row.status) === 'success'"
                          [class.status-badge--danger]="statusBadgeClass(row.status) === 'danger'"
                          [class.status-badge--secondary]="statusBadgeClass(row.status) === 'secondary'">{{ row.status }}</span>
                  } @else {
                    <span class="text-muted">-</span>
                  }
                </td>
                <td>{{ row.message || '-' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <span class="text-body-secondary small">Total {{ pageData().page?.totalElements ?? 0 }} records</span>
    <ngb-pagination [collectionSize]="pageData().page.totalElements"
                    [page]="pageData().page.number + 1"
                    [pageSize]="pageData().page.size"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="search($event)">
    </ngb-pagination>
  </div>
</div>

<div class="alert alert-info alert-dismissible fade show mt-3" role="alert">
  <strong>หมายเหตุ</strong><br/>
  ข้อมูล Log จะถูกเก็บไว้นานสูงสุด {{ retentionDays() }} วัน
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>
